// extracted by mini-css-extract-plugin
export default {"container":"TabsCostsEarningCard_container__eWUw-","loaderContainer":"TabsCostsEarningCard_loaderContainer__1hJpZ","loader":"TabsCostsEarningCard_loader__gdgnX"};